import { useState } from 'react';
import { Notice } from '@voice/ui';
import type { DeviceCredentials } from '../lib/types';
import styles from '../pages/Pages.module.css';

function CopyButton({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className={styles.copy}
      aria-label={`${label} kopieren`}
      onClick={() => {
        void navigator.clipboard?.writeText(value).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        });
      }}
    >
      {copied ? 'Kopiert' : 'Kopieren'}
    </button>
  );
}

/** Zeigt die Zugangsdaten eines neuen Geräts – das Passwort nur dieses eine Mal. */
export function CredentialsPanel({ credentials, displayName }: { credentials: DeviceCredentials; displayName: string }) {
  const c = credentials.connection;
  const port = c.transport === 'TLS' ? c.tlsPort : c.transport === 'TCP' ? c.tcpPort : c.udpPort;
  const rows: [string, string][] = [
    ['Server', port ? `${c.server}:${port}` : c.server],
    ['Domain', c.domain],
    ['Benutzername', credentials.username],
    ['Passwort', credentials.password],
    ['Transport', c.transport],
    ['Anzeigename', displayName],
  ];
  return (
    <>
      <Notice tone="success">Das Passwort wird nur jetzt angezeigt. Bitte direkt im Telefon eintragen oder sicher ablegen. Bei Verlust vergibst du ein neues.</Notice>
      <dl className={styles.credentials}>
        {rows.map(([k, v]) => (
          <div key={k} style={{ display: 'contents' }}>
            <dt>{k}</dt>
            <dd>
              <span>{v}</span>
              <CopyButton value={v} label={k} />
            </dd>
          </div>
        ))}
      </dl>
      <div>
        <h3 className={styles.heading}>Einrichtung in MicroSIP</h3>
        <ol className={styles.steps}>
          <li>Menü → <em>Add Account</em> (Konto hinzufügen).</li>
          <li>SIP-Server und Domain wie oben eintragen, <em>SIP Proxy</em> leer lassen.</li>
          <li>Benutzername und Passwort eintragen, <em>Login</em> leer lassen (entspricht dem Benutzernamen).</li>
          <li>Transport auf <strong>{c.transport}</strong> stellen{c.transport === 'TLS' ? ', Verschlüsselung der Sprache (SRTP) auf „Optional“ oder „Mandatory“' : ''}.</li>
          <li>Speichern. Der Punkt neben dem Konto wird grün, sobald die Anmeldung geklappt hat.</li>
        </ol>
        <p className={styles.muted} style={{ marginTop: 8 }}>
          Die Bezeichnungen können je nach MicroSIP-Version leicht abweichen. Andere Telefone (Zoiper, Linphone, Tischtelefone) brauchen dieselben Angaben.
        </p>
      </div>
    </>
  );
}
